module.exports = __webpack_public_path__ + "img/clicktech.ddeba90c.svg";